import axios from 'axios';
import { AFISHA_BASE_API_URL, REQUEST_TIMEOUT_SECONDS } from '../constants';

export default axios.create({
  baseURL: AFISHA_BASE_API_URL,
  responseType: 'json',
  timeout: REQUEST_TIMEOUT_SECONDS,
  withCredentials: true
});
